<template>
  <tr>
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal" />
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal" />
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal">
      {{ $t("common.quantity") }}
    </th>
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal">
      {{ $t("auction.effective_price") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_2' || auction.auctionStatus == 'CLOSED'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal"
    >
      {{ $t('lot.assigned_quantity') }}
    </th>
    <th
      v-if="auction.auctionStatus == 'OPEN' || auction.auctionStatus == 'PUBLISHED'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal"
    >
      {{ $t("auction.expiration") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'OPEN'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal"
    >
      {{ $t("auction.remaining") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'OPEN'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal hidden md:table-cell"
    >
      {{ $t("auction.bid") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'OPEN'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal"
    >
      {{ $t("auction.bid_count") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_2' || auction.auctionStatus == 'CLOSED'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal hidden md:table-cell"
    />
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal" />
  </tr>
</template>

<script setup>
const props = defineProps({
    auction: {
        type: Object,
        required: true
    }
})
</script>